import React, { useState, useEffect } from "react";
import config from "../config.json";
import { customTheme } from "../customTheme";
import { useRefresh } from 'react-admin';
import {
    useMediaQuery, makeStyles, Button, Dialog, DialogContent,
    DialogActions, CircularProgress, DialogContentText, IconButton
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import CloseIcon from '@material-ui/icons/Close';
import ImageGalleryDialog from './ImageGalleryDialog';
import imageCompression from 'browser-image-compression';
import Transmission from '../images/Transmission.svg'
import Fuel from '../images/Fuel.svg'
import G1 from '../images/Group 5141.svg'
import G2 from '../images/Group 5142.svg'
import Path from '../images/Path679.png'
import BikeBlack from '../images/BikeBlack.png'
import BikeBlue from '../images/BikeBlue.png'
import BikeGray from '../images/BikeGray.png'
import BikeRed from '../images/BikeRed.png'
import BikeWhite from '../images/BikeWhite.png'
import CarBlack from '../images/CarBlack.png'
import CarBlue from '../images/CarBlue.png'
import CarGray from '../images/CarGray.png'
import CarRed from '../images/CarRed.png'
import CarWhite from '../images/CarWhite.png'
import { saveTokens } from '../utils/saveTokens';
import notify from './CustomUseNotify';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import { hideVehicleNumber } from "../sharedData";
import moment from "moment";
// import { vehicleSvgs } from "../sharedData";

const useStyles = makeStyles({
    list: {
        marginBottom: 0,
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
    },
    dialogPaper: {
        borderRadius: 15,
        padding: "5px 15px 15px",
        maxWidth: 350
    },
    dialogButton: {
        borderRadius: 100,
        padding: "8px 25px"
    },
    dialogPaperBig: {
        borderRadius: 15,
        padding: "5px 5px 10px",
    },
    input: {
        width: "500px"
    },
    MuiInputBase: {
        root: {
            width: "800px"
        }
    },
    chipCell: {
        textAlign: "center",
        padding: customTheme.spacing(1, 2),
        display: "inline-block",
        borderRadius: 50,
        minWidth: 100,
    },
    uploadButton: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        border: "1px solid #BDBDBD",
        width: "140px",
        borderRadius: 5,
        height: "80px",
        padding: 0,
        minWidth: 0
    },
    uploadButtonInput: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        opacity: 0,
        "&:hover": {
            cursor: "pointer"
        }
    },
    vehicleTypeButton: {
        flex: 1,
        borderWidth: 1,
        borderStyle: "solid",
        borderRadius: 10,
        backgroundColor: "#f5f8fa",
        padding: "14px 10px",
        fontFamily: "Poppins-Medium",
        fontWeight: 500,
        textTransform: "none",
        color: "#222"
    },
});

const UserVehicles = ({ record, searchId, searchEndpoint }) => {
    const [displayModal, setDisplayModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [userVehicles, setUserVehicles] = useState([]);

    const getUserVehicles = () => {
        setLoading(true)
        fetch(`${config.HOST_NAME}/crm/v3/${searchEndpoint}?id=${searchId}&vehicle_type=${record.vehicle_type}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            }
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                setLoading(false);
                if (json.success) {
                    setDisplayModal(true)
                    setUserVehicles(json.data)
                } else notify(json.message, 'warning')
            })
            .catch(e => {
                setLoading(false)
                notify('Something went wrong', 'warning')
                console.log(e)
            });
    };

    return (
        <>
            <div style={{ cursor: "pointer" }} onClick={() => { getUserVehicles() }}>
                <div className='fontWeightSemiBold secondaryColor'>{hideVehicleNumber(record.vehicle_number)} {loading && <CircularProgress color="secondary" size={12} style={{ marginLeft: "10px" }} />}</div>
                {record.chassis_number !== "" && record.chassis_number !== null && <div className="logsTableDataColor2 fontWeightMedium" style={{ marginTop: 1, fontSize: 10, width: 78, overflow: "hidden", textOverflow: "ellipsis" }}>{record.chassis_number}</div>}
            </div>

            {displayModal && userVehicles.length > 0 && <CustomModal displayModal={displayModal} setDisplayModal={setDisplayModal} vehicleUsers={userVehicles} setUserVehicles={setUserVehicles} />}
        </>
    );
}

const renderVehicleColor = (type, color) => {
    if (type === "4") {
        if (color === "Red") {
            return CarRed
        } else if (color === "Black") {
            return CarBlack
        } else if (color === "White") {
            return CarWhite
        } else if (color === "Gray") {
            return CarGray
        } else {
            return CarBlue
        }
    }
    if (type === "2") {
        if (color === "Red") {
            return BikeRed
        } else if (color === "Black") {
            return BikeBlack
        } else if (color === "White") {
            return BikeWhite
        } else if (color === "Gray") {
            return BikeGray
        } else {
            return BikeBlue
        }
    }
}

const UploadImageButton = ({ onImageUpload }) => {
    const classes = useStyles();
    return <Button className={classes.uploadButton}>
        <AddIcon style={{ fontSize: 40, color: "#444" }} />
        <input
            type="file"
            accept="image/png, image/jpeg"
            className={classes.uploadButtonInput}
            onChange={onImageUpload}
        />
    </Button>
}
const EditImageIconButton = ({ onImageUpload, style }) => {
    const classes = useStyles();
    return <Button className={classes.uploadButton} style={{ borderRadius: 1000, width: 25, height: 25, backgroundColor: "#0007", border: "none", ...style }}>
        <EditIcon style={{ fontSize: 17, color: "#fff" }} />
        <input
            type="file"
            accept="image/png, image/jpeg"
            className={classes.uploadButtonInput}
            style={{ borderRadius: 1000 }}
            onChange={onImageUpload}
        />
    </Button>
}

const CustomModal = ({ displayModal, setDisplayModal, vehicleUsers, setUserVehicles, allowVerification }) => {
    const classes = useStyles();
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));

    const [currentIndex, setCurrentIndex] = useState(0);
    const [images, setImages] = useState([]);
    // const [loading, setLoading] = useState(false);
    const [changeVehicleTypeDialogVisible, setChangeVehicleTypeDialogVisible] = useState(false);

    const updateVehicle = (updated) => {
        setUserVehicles(uV => {
            const temp = [...uV];
            temp[currentIndex] = { 
                ...temp[currentIndex],
                ...updated
            };
            return temp;
        });
    }

    const arrowHandler = (type) => {
        if (type === 1) {
            setCurrentIndex(prev => prev + 1)
        }
        if (type === 0) {
            setCurrentIndex(prev => prev - 1)
        }
    };

    const imagesHandler = () => {
        const images = []
        if (vehicleUsers[currentIndex].rc_image_url) {
            images.push(vehicleUsers[currentIndex].rc_image_url)
        } if (vehicleUsers[currentIndex].id_proof_url) {
            images.push(vehicleUsers[currentIndex].id_proof_url)
        } if (vehicleUsers[currentIndex].id_proof_back_url) {
            images.push(vehicleUsers[currentIndex].id_proof_back_url)
        }
        setImages(images)
    };

    const uploadImage = async (imageName, files) => {
        if(files && files[0]) {
            const imageFile = files[0];

            const vehicleProp = `${imageName}_url`;
            let tempUrl = URL.createObjectURL(imageFile);
            const prevValue = vehicleUsers[currentIndex][vehicleProp];
            updateVehicle({ [vehicleProp]: tempUrl });

            const options = {
                maxSizeMB: 1.5,
                maxWidthOrHeight: 1920,
                useWebWorker: true,
            }
            try {
                const compressedFile = await imageCompression(imageFile, options);
                tempUrl = URL.createObjectURL(compressedFile);
                updateVehicle({ [vehicleProp]: tempUrl });

                const data = new FormData();
                data.append("vehicle_id", vehicleUsers[currentIndex].id);
                data.append(imageName, compressedFile, imageName);

                fetch(`${config.HOST_NAME}/crm/uploadVehicleImages`, {
                    method: 'PUT',
                    headers: {
                        'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                        'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                    },
                    body: data,
                })
                .then(response => response.json())
                .then(json => {
                    if (json.success) {
                        notify(json.message, "success");
                    } else {
                        updateVehicle({ [vehicleProp]: prevValue });
                        notify(json.message, "warning");
                    }
                })
                .catch((error) => {
                    updateVehicle({ [vehicleProp]: prevValue });
                    notify("Something Went Wrong", "warning");
                });
            } catch (error) {
                updateVehicle({ [vehicleProp]: prevValue });
                console.log(error);
            }
        }
    };

    // const openChangeVehicleTypeDialog = () => {
    //     setChangeVehicleTypeDialogVisible(true);
    // };

    const closeChangeVehicleTypeDialog = () => {
        setChangeVehicleTypeDialogVisible(false);
    };

    const updateVehicleType = () => {

    };

    useEffect(() => {
        imagesHandler()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentIndex]);

    return (
        <div>
            <div className={`CustomModal ${displayModal ? "Show" : ""}`} style={{ width: vehicleUsers.length > 1 ? '40%' : '20%' }}>

                <div style={{ display: 'flex', justifyContent: 'center', alignItems: "center" }}>

                    {vehicleUsers.length > 1 && <IconButton
                        onClick={() => arrowHandler(0)}
                        disabled={currentIndex === 0}
                        style={{ marginTop: 20 }}
                    >
                        <NavigateBeforeIcon />
                    </IconButton>}

                    <div className='siteAuditsScroll' style={{ overflow: "auto", overflowX: "hidden", height: "calc(100vh - 50px)", margin: "0px 0px 0px 0px", padding: "10px 20px 20px 20px", color: "#272727" }}>

                        <div style={{ display: "flex", justifyContent: 'space-between', alignItems: "center", marginBottom: 15, columnGap: 10 }}>
                            <div>
                                <p style={{ fontWeight: "bold", lineHeight: "3px" }}><span>{vehicleUsers[currentIndex].vehicle_number.replace(/\d*$/, "")}</span>  <span style={{ color: "#18cc69" }}>{vehicleUsers[currentIndex].vehicle_number.match(/\d*$/)}</span></p>
                                <p style={{ fontSize: 12, color: "#BDBDBD", fontWeight: 500, lineHeight: "3px" }}>{vehicleUsers[currentIndex].brand ? vehicleUsers[currentIndex].brand : "Unknown"} {vehicleUsers[currentIndex].model ? vehicleUsers[currentIndex].model : "Unknown"}</p>
                            </div>
                            <IconButton
                                onClick={() => setDisplayModal(!displayModal)}
                            >
                                <CloseIcon />
                            </IconButton>
                        </div>
                        {/* <div style={{ display: "flex", justifyContent: "space-between", gap: 15, marginBottom: 10 }}>
                            <Button onClick={openChangeVehicleTypeDialog} className={classes.vehicleTypeButton} style={{ borderColor: vehicleUsers[currentIndex].vehicle_type === "2" ? customTheme.palette.primary.main : "#0000" }} disabled={vehicleUsers[currentIndex].vehicle_type === "2"}>
                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 5, color: "#222" }}>
                                    <img src={vehicleSvgs["2"]} alt="2-Wheeler" style={{ height: 20 }} /> 2-Wheeler
                                </div>
                            </Button>
                            <Button onClick={openChangeVehicleTypeDialog} className={classes.vehicleTypeButton} style={{ borderColor: vehicleUsers[currentIndex].vehicle_type === "4" ? customTheme.palette.primary.main : "#0000" }} disabled={vehicleUsers[currentIndex].vehicle_type === "4"}>
                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 5, color: "#222" }}>
                                    <img src={vehicleSvgs["4"]} alt="4-Wheeler" style={{ height: 20 }} /> 4-Wheeler
                                </div>
                            </Button>
                        </div> */}
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", columnGap: 1, overflow: "hidden", position: "relative" }}>
                            <img style={{ position: "absolute", right: isSmallDevice ? "-22px" : "0px", cursor: "pointer", top: "0px" }} src={Path} alt='path' />
                            <div style={{ width: "50%" }}>
                                <div style={{ display: "flex", justifyContent: "start", alignItems: "center", columnGap: 10, marginBottom: 5 }}>
                                    <img src={Transmission} alt="Transmission" />
                                    <div>
                                        <p style={{ fontSize: 12, color: "#BDBDBD", fontWeight: 500, lineHeight: "3px" }}>Transmission</p>
                                        <p style={{ fontSize: 14, fontWeight: "500", lineHeight: "3px" }}>{vehicleUsers[currentIndex].fuel_transmission ? vehicleUsers[currentIndex].fuel_transmission : "Unknown"}</p>
                                    </div>
                                </div>
                                <div style={{ display: "flex", justifyContent: "start", alignItems: "center", columnGap: 10, marginBottom: 5 }}>
                                    <img src={Fuel} alt="fuel" />
                                    <div marginLeft={.7}>
                                        <p style={{ fontSize: 12, color: "#BDBDBD", fontWeight: 500, lineHeight: "3px" }}>Fuel</p>
                                        <p style={{ fontSize: 14, fontWeight: "500", lineHeight: "3px" }}>{vehicleUsers[currentIndex].fuel_type ? vehicleUsers[currentIndex].fuel_type : "Unknown"}</p>
                                    </div>
                                </div>
                                <div style={{ display: "flex", justifyContent: "start", alignItems: "center", columnGap: 10, marginBottom: 5 }}>
                                    <img src={vehicleUsers[currentIndex].verified === 1 ? G1 : G2} style={{ width: 26, height: 26, marginLeft: -1 }} alt="verify" />
                                    <div style={{ marginLeft: -1 }}>
                                        <p style={{ fontSize: 12, color: "#BDBDBD", fontWeight: 500, lineHeight: "3px" }}>Verification</p>
                                        <p style={{ fontSize: 14, fontWeight: "500", lineHeight: "3px" }}>{vehicleUsers[currentIndex].verified === 1 ? "Verified" : "Not Verified"}</p>
                                    </div>
                                </div>
                                <div style={{ display: "flex", justifyContent: "start", alignItems: "center", columnGap: 10, marginBottom: 5 }}>
                                    <img src={Transmission} alt="Transmission" />
                                    <div>
                                        <p style={{ fontSize: 12, color: "#BDBDBD", fontWeight: 500, lineHeight: "3px" }}>Chassis Number</p>
                                        <p style={{ fontSize: 14, fontWeight: "500", lineHeight: "3px" }}>{vehicleUsers[currentIndex].chassis_number ? vehicleUsers[currentIndex].chassis_number : "Unknown"}</p>
                                    </div>
                                </div>
                                <div style={{ display: "flex", justifyContent: "start", alignItems: "center", columnGap: 10, marginBottom: 5 }}>
                                    <img src={Transmission} alt="Transmission" />
                                    <div>
                                        <p style={{ fontSize: 12, color: "#BDBDBD", fontWeight: 500, lineHeight: "3px" }}>Pucc Validity</p>
                                        <p style={{ fontSize: 14, fontWeight: "500", lineHeight: "3px" }}>{vehicleUsers[currentIndex].pucc_validity ? moment(vehicleUsers[currentIndex].pucc_validity).format("DD/MM/YYYY") : "Unknown"}</p>
                                    </div>
                                </div>
                                <div style={{ display: "flex", justifyContent: "start", alignItems: "center", columnGap: 10, marginBottom: 5 }}>
                                    <img src={Transmission} alt="Transmission" />
                                    <div>
                                        <p style={{ fontSize: 12, color: "#BDBDBD", fontWeight: 500, lineHeight: "3px" }}>Insurance Validity</p>
                                        <p style={{ fontSize: 14, fontWeight: "500", lineHeight: "3px" }}>{vehicleUsers[currentIndex].insurance_validity ? moment(vehicleUsers[currentIndex].insurance_validity).format("DD/MM/YYYY") : "Unknown"}</p>
                                    </div>
                                </div>
                            </div>
                            <div style={{ width: "50%", display: "flex", alignItems: "end", justifyContent: "end" }}>
                                <img style={{ width: "80%", minWidth: "230px", marginRight: "-70px" }} src={renderVehicleColor(vehicleUsers[currentIndex].vehicle_type, vehicleUsers[currentIndex].vehicle_color)} alt="Vehicle" />
                            </div>
                        </div>

                        <div>
                            <p style={{ fontSize: 14, lineHeight: "3px", fontWeight: "bold" }}>Vehicle Documents</p>

                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 5 }}>
                                <div>
                                    <p style={{ fontSize: 12, color: "#BDBDBD", fontWeight: 500, lineHeight: "3px" }}>RC Proof</p>
                                    {vehicleUsers[currentIndex].rc_image_url ?
                                        <div style={{ position: "relative" }}>
                                            <ImageGalleryDialog style={{ textAlign: "none" }} thumbnail={true} thumbnailStyle={{ minWidth: "80px", width: "140px", borderRadius: 10, height: "80px", border: "1px solid #BDBDBD", padding: 2 }} record={images} getImages={img => [vehicleUsers[currentIndex].rc_image_url]} />
                                            <EditImageIconButton onImageUpload={event => uploadImage("rc_image", event.target.files)} style={{ position: "absolute", top: 8, right: 15 }} />
                                        </div>
                                    :
                                        <UploadImageButton onImageUpload={event => uploadImage("rc_image", event.target.files)} />
                                    }
                                </div>
                                <div>
                                    <p style={{ fontSize: 12, color: "#BDBDBD", fontWeight: 500, lineHeight: "3px" }}>ID Proof Front</p>
                                    {vehicleUsers[currentIndex].id_proof_url ?
                                        <div style={{ position: "relative" }}>
                                            <ImageGalleryDialog style={{ textAlign: "none" }} thumbnail={true} thumbnailStyle={{ minWidth: "80px", width: "140px", borderRadius: 5, height: "80px", border: "1px solid #BDBDBD", padding: 2 }} record={images} getImages={img => [vehicleUsers[currentIndex].id_proof_url]} />
                                            <EditImageIconButton onImageUpload={event => uploadImage("id_proof", event.target.files)} style={{ position: "absolute", top: 8, right: 15 }} />
                                        </div>
                                    :
                                        <UploadImageButton onImageUpload={event => uploadImage("id_proof", event.target.files)} />
                                    }
                                </div>
                                <div>
                                    <p style={{ fontSize: 12, color: "#BDBDBD", fontWeight: 500, lineHeight: "3px" }}>ID Proof Back</p>
                                    {vehicleUsers[currentIndex].id_proof_back_url ?
                                        <div style={{ position: "relative" }}>
                                            <ImageGalleryDialog style={{ textAlign: "none" }} thumbnail={true} thumbnailStyle={{ minWidth: "80px", width: "140px", borderRadius: 5, height: "80px", border: "1px solid #BDBDBD", padding: 2 }} record={images} getImages={img => [vehicleUsers[currentIndex].id_proof_back_url]} />
                                            <EditImageIconButton onImageUpload={event => uploadImage("id_proof_back", event.target.files)} style={{ position: "absolute", top: 8, right: 15 }} />
                                        </div>
                                    :
                                        <UploadImageButton onImageUpload={event => uploadImage("id_proof_back", event.target.files)} />
                                    }
                                </div>
                            </div>

                            {vehicleUsers[currentIndex].verified !== 1 && allowVerification &&
                                <VerifyVehicleConfirmation vehicleUsers={vehicleUsers[currentIndex]} displayModal={displayModal} setDisplayModal={setDisplayModal} />
                            }
                        </div>
                    </div>

                    {vehicleUsers.length > 1 && <IconButton
                        onClick={() => arrowHandler(1)}
                        disabled={currentIndex + 1 === vehicleUsers.length}
                        style={{ marginTop: 20 }}
                    >
                        <NavigateNextIcon />
                    </IconButton>}
                </div>
            </div>
            <div
                className={`CustomOverlay ${displayModal ? "Show" : ""}`}
                onClick={() => setDisplayModal(!displayModal)}
            />

            <Dialog
                open={changeVehicleTypeDialogVisible}
                onClose={closeChangeVehicleTypeDialog}
                fullWidth
                classes={{ paper: classes.dialogPaper }}
                BackdropProps={{
                    classes: {
                        root: classes.backDrop
                    }
                }}
            >
                <DialogContent>
                    <div style={{ fontFamily: "Poppins-Regular", fontWeight: 500 }}>
                        Are you sure you want to change this vehicle to <span style={{ fontWeight: 600 }}>{vehicleUsers[currentIndex].vehicle_type === "2" ? "4-Wheeler" : "2-Wheeler"}</span>?
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeChangeVehicleTypeDialog} color="error" variant='contained' style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: "#E7EBF0", color: "#334D6E" }} disableElevation>
                        No
                    </Button>
                    <Button onClick={updateVehicleType} color="contained" variant='contained' style={{ backgroundColor: '#18cc69', color: "#FFF", textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", }} autoFocus disableElevation>
                        Yes 
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}
// {loading && <CircularProgress color="inherit" size={14} style={{ marginLeft: 15 }} />}
const VerifyVehicleConfirmation = ({ vehicleUsers, displayModal, setDisplayModal }) => {
    const classes = useStyles();
    //const notify = useNotify();
    const refresh = useRefresh();
    const [logoutDialogVisible, setlogoutDialogVisible] = React.useState(false);
    const [loading, setLoading] = useState(false)

    const handleOpen = () => {
        setlogoutDialogVisible(true)
    }

    const handleClose = () => {
        setlogoutDialogVisible(false)
    }

    const updateVehicleVerifyStatus = () => {
        setLoading(true)
        fetch(`${config.HOST_NAME}/crm/v3/updateVehicleVerifyStatus`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
            body: JSON.stringify({ vehicle_number: vehicleUsers.vehicle_number })
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                if (json.success) {
                    notify(json.message, "success");
                    setLoading(false)
                    setDisplayModal(!displayModal)
                    handleClose()
                    refresh()
                } else {
                    notify(json.message, "warning");
                    setLoading(false)
                }
            })
            .catch((error) => {
                setLoading(false);
                notify("Something Went Wrong", "warning");
            });
    }

    return (

        <div>
            <Button onClick={handleOpen} color="contained" variant='contained' style={{ backgroundColor: '#18cc69', color: "#FFF", textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", width: "100%", borderRadius: 50, marginTop: 10 }} disableElevation>
                Verify
            </Button>
            <Dialog
                open={logoutDialogVisible}
                onClose={handleClose}
                fullWidth
                classes={{ paper: classes.dialogPaper }}
                BackdropProps={{
                    classes: {
                        root: classes.backDrop
                    }
                }}
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to verify this <strong>Vehicle</strong>.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="error" variant='contained' style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: "#E7EBF0", color: "#334D6E" }} disableElevation>
                        No
                    </Button>
                    <Button onClick={updateVehicleVerifyStatus} color="contained" variant='contained' style={{ backgroundColor: '#18cc69', color: "#FFF", textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", }} autoFocus disableElevation>
                        Yes {loading && <CircularProgress color="inherit" size={14} style={{ marginLeft: 15 }} />}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default UserVehicles;
